import {
  getClassroomDetails,
  listSnapshots,
  createBackup,
  listClassrooms,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/google/recovery/classroom/classroom";
import {defaultPagination} from "@/services/pagination";
import announcement from "@/store/app/google/recovery/classroom/data-set/announcement";
import classwork from "@/store/app/google/recovery/classroom/data-set/classwork";
import classworkDrive from "@/store/app/google/recovery/classroom/data-set/drive";
import grade from "@/store/app/google/recovery/classroom/data-set/grade";
import people from "@/store/app/google/recovery/classroom/data-set/people";
import wholeClass from "@/store/app/google/recovery/classroom/data-set/wholeClass";
import exports from "@/store/app/google/recovery/classroom/exports";
import restores from "@/store/app/google/recovery/classroom/restores";
import backups from "@/store/app/google/recovery/classroom/backups";
import user from "@/store/app/google/recovery/classroom/user";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";

const defaultState = () => ({
  classrooms: [],
  classroomMap: {},
  listRegions: {},
  listRegionsGcp: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null
});

export default {
  namespaced: true,
  actions: {
    listClassrooms({commit, state},) {
      return listClassrooms({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setClassrooms', result)
          commit('setPagination', pagination)
        })
    },
    getClassroomDetails({commit}, classroomId) {
      return getClassroomDetails(classroomId)
        .then(classroom => {
          commit('setClassroom', classroom);
          return classroom;
        })
    },
    createBackup({commit}, classroomId) {
      return createBackup(classroomId);
    },
    listSnapshots({commit}, {classroomId, date, dateTo}) {
      return listSnapshots({classroomId, date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '16'
      });
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
  },

  mutations: {
    setClassrooms(state, classrooms) {
      state.classrooms = classrooms;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'name',
          sortDescending: false
        };
      }

    },
    setSearchFiles(state, search) {
      state.search = search;
    },
    setClassroom(state, classroom) {
      state.classroomMap = {
        ...state.classroomMap,
        [classroom.classroomId]: classroom
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getClassroomById: (state) => (id) => {
      return state.classroomMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState,

  modules: {
    announcement,
    classwork,
    drive: classworkDrive,
    grade,
    people,
    wholeClass,
    exports,
    restores,
    backups,
    user
  },
}
